import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var RichText = function RichText(props) {
  var _getThemeData = getThemeData(props, 'richtext'),
    borderColor = _getThemeData.borderColor;
  return css([".ql-container.ql-snow,.ql-toolbar.ql-snow{border-color:", ";}.c7n-pro-rich-text-quill.c7n-pro-rich-text-quill{}"], borderColor);
};
export default RichText;